"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcWorksheetHeader = class UcWorksheetHeader extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    worksheet;
    onWorksheet(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("worksheet");
    }
    messages;
    ux;
    dataMembers = ['messages', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    typeName: this.$fn.pgettext("Worksheet", "Worksheet"),
                    newTransaction: this.$fn.pgettext("Worksheet", "New Worksheet"),
                },
                ux: null,
            },
        };
    }
    get readonly() {
        if (this.loaded) {
            return this.worksheet.locked;
        }
        return null;
    }
    get isNew() {
        if (this.loaded) {
            return this.worksheet.isNew;
        }
        return null;
    }
    get resourceTitle() {
        if (this.loaded) {
            return this.messages.typeName;
        }
        return null;
    }
    get resourceKey() {
        if (this.loaded) {
            return this.isNew ? this.messages.newTransaction : this.worksheet.snapshot('number');
        }
        return null;
    }
    async act_6424600534600827_emit_8334_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_6424600534600827_close_8333_getWhen($event) {
        return $event.data.modalResult.ok;
    }
    async act_6424600534600827_showModal_8332_getActionArgs($event) {
        return {
            name: "WorksheetEditor",
            props: {
                worksheet: _.cloneDeep(this.worksheet),
            },
        };
    }
    async evh_6424600534600827_clickPreventStop(event, scope) {
        return await this.actions.evh_6424600534600827_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_8249915319319009_emit_8336_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_8249915319319009_clickPreventStop(event, scope) {
        return await this.actions.evh_8249915319319009_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_1890060294221449_emit_8338_getActionArgs($event) {
        return {
            event: "deleted",
        };
    }
    async evh_1890060294221449_success(event, scope) {
        return await this.actions.evh_1890060294221449_success.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_6424600534600827_emit_8334 = new core_1.actions.EmitAction({
            actionArgs: this.act_6424600534600827_emit_8334_getActionArgs,
            events: [],
        });
        const evh_6424600534600827_close_8333 = new core_1.actions.EventHandlerImpl({
            action: act_6424600534600827_emit_8334,
            event: "close",
            when: this.evh_6424600534600827_close_8333_getWhen,
            displayName: "emit",
        });
        const act_6424600534600827_showModal_8332 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_6424600534600827_showModal_8332_getActionArgs,
            events: [evh_6424600534600827_close_8333],
        });
        const evh_6424600534600827_clickPreventStop_8331 = new core_1.actions.EventHandlerImpl({
            action: act_6424600534600827_showModal_8332,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_6424600534600827_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6424600534600827_clickPreventStop_8331],
        });
        const act_8249915319319009_emit_8336 = new core_1.actions.EmitAction({
            actionArgs: this.act_8249915319319009_emit_8336_getActionArgs,
            displayName: "reload",
            events: [],
        });
        const evh_8249915319319009_clickPreventStop_8335 = new core_1.actions.EventHandlerImpl({
            action: act_8249915319319009_emit_8336,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_8249915319319009_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8249915319319009_clickPreventStop_8335],
        });
        const act_1890060294221449_emit_8338 = new core_1.actions.EmitAction({
            actionArgs: this.act_1890060294221449_emit_8338_getActionArgs,
            events: [],
        });
        const evh_1890060294221449_success_8337 = new core_1.actions.EventHandlerImpl({
            action: act_1890060294221449_emit_8338,
            event: "success",
            displayName: "emit",
        });
        const evh_1890060294221449_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1890060294221449_success_8337],
        });
        return {
            act_6424600534600827_emit_8334,
            evh_6424600534600827_close_8333,
            act_6424600534600827_showModal_8332,
            evh_6424600534600827_clickPreventStop_8331,
            evh_6424600534600827_clickPreventStop,
            act_8249915319319009_emit_8336,
            evh_8249915319319009_clickPreventStop_8335,
            evh_8249915319319009_clickPreventStop,
            act_1890060294221449_emit_8338,
            evh_1890060294221449_success_8337,
            evh_1890060294221449_success,
            reload: act_8249915319319009_emit_8336,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcWorksheetHeader.prototype, "worksheet", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('worksheet'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcWorksheetHeader.prototype, "onWorksheet", null);
UcWorksheetHeader = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcWorksheetHeader);
exports.default = UcWorksheetHeader;
vue_property_decorator_1.Vue.component("UcWorksheetHeader", UcWorksheetHeader);
